import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import { selectionTypes } from '../helpers'

{
  ROW
  COL
  CELL
  MULTI_CELL
  MULTI_ROW
  MULTI_COL
} = selectionTypes

export default withCellBorderBuilder = (r, c) ->

  [{ columns, edits, rowsToBeDeleted, selection, selectionType }] = useSpreadSheetData()

  cNames = ["grid-cell"]

  selectionTypeUnspecificBorders = (fn) ->
    if edits[r]?[c] then cNames.push('has-unsaved-changes')
    if rowsToBeDeleted[r] then cNames.push('scheduled-for-deletion')
    if c is -1 then cNames.push('col-starter')
    if r is -1 then cNames.push('row-starter')
    if r is 0 then cNames.push('row-seconder')
    if (r % 2) is 0 then cNames.push('alternate-row')
    if !(columns[c]?.editFn or columns[c]?.relationConf) then cNames.push('read-only')

    fn(r, c)
    cNames.join(' ')

  inRange = (x, min, max) ->
    return ((x - min) * (x - max) <= 0)

  isInBoundingBox = ([x, y], [a, d]) ->
    return (
      inRange(x, a[0], d[0]) and
      inRange(y, a[1], d[1])
    )

  rowSelectedBorders = (r, c) ->
    if selection is r
      cNames.push('active')

  colSelectedBorders = (r, c) ->
    if selection is c
      cNames.push('active')

  cellSelectedBorders = (r, c) ->
    if _.isEqual(selection, [c, r])
      cNames.push('active')

  multiCellSelectedBorders = (r, c) ->
    if isInBoundingBox([c, r], selection)
      cNames.push('active')

  multiRowSelectedBorders = (r, c) ->
    [a, b] = selection
    if inRange(r, a, b)
      cNames.push('active')

  multiColSelectedBorders = (r, c) ->
    [a, b] = selection
    if inRange(c, a, b)
      cNames.push('active')

  fn = switch selectionType
    when ROW then rowSelectedBorders
    when COL then colSelectedBorders
    when CELL then cellSelectedBorders
    when MULTI_CELL then multiCellSelectedBorders
    when MULTI_ROW then multiRowSelectedBorders
    when MULTI_COL then multiColSelectedBorders
    else ( -> )

  selectionTypeUnspecificBorders(fn)